import { render, staticRenderFns } from "./ContactoData.vue?vue&type=template&id=14f696f4&"
import script from "./ContactoData.vue?vue&type=script&lang=js&"
export * from "./ContactoData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports